import { RefreshCw, AlertCircle } from "lucide-react";
import { useNovexData } from "@/hooks/useNovexData";
import { useLang } from "@/context/LanguageContext";
import { DataRenderer } from "@/components/DataRenderer";
import { ExplainButton } from "@/components/ExplainButton";
import { Button } from "@/components/ui/button";

export function CategoryView({ cat, kind = "donnée macro", compact = false, showExplain = true }) {
  const { t } = useLang();
  const { status, data, error, reload } = useNovexData(`/novex/category/${cat}`);
  const results = data?.results || [];

  if (status === "loading") {
    return (
      <div className="space-y-3">
        {[...Array(compact ? 1 : 2)].map((_, i) => <div key={i} className="h-24 animate-pulse rounded-md bg-slate-800/50" />)}
      </div>
    );
  }
  if (error) {
    return (
      <div className="flex items-center justify-between rounded-md border border-[#222733] bg-[#11141A] p-3 text-sm text-amber-500/80">
        <span className="flex items-center gap-2"><AlertCircle className="h-4 w-4" /> {error}</span>
        <Button variant="ghost" size="sm" onClick={reload} className="gap-1.5"><RefreshCw className="h-3.5 w-3.5" /> {t("cv.retry")}</Button>
      </div>
    );
  }
  if (results.length === 0) {
    return <p className="text-sm text-slate-500">{t("cv.none")}</p>;
  }

  return (
    <div className={`space-y-5 ${compact ? "max-h-[420px] overflow-y-auto pr-1" : ""}`}>
      {results.map((r, i) => (
        <div key={i} className="animate-fade-in">
          {(r.description || results.length > 1) && (
            <div className="mb-2 flex items-center justify-between gap-2">
              <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">{r.description || r.tool}</span>
              {showExplain && !r.error && (
                <ExplainButton kind={kind} text={`${r.description || r.tool}\n${JSON.stringify(r.data).slice(0, 3500)}`} testid={`explain-${cat}-${i}`} label={t("c.explain")} />
              )}
            </div>
          )}
          {r.error ? <p className="text-xs text-amber-500/80">{r.error}</p> : <DataRenderer data={r.data} />}
        </div>
      ))}
    </div>
  );
}
